import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { AuthModal } from "@/components/AuthModal";
import { Landing } from "@/pages/Landing";
import { Processing } from "@/pages/Processing";
import { Dashboard } from "@/pages/Dashboard";
import { PaymentStatus } from "@/pages/PaymentStatus";
import { Toaster } from "@/components/ui/sonner";
import { GlobalFooter } from "@/components/GlobalFooter";
import LegalPage from "@/pages/LegalPage";

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <AuthProvider>
          <Navbar />
          <AuthModal />
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/processing/:projectId" element={<Processing />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/payment/success" element={<PaymentStatus />} />
            <Route path="/payment/cancel" element={<PaymentStatus cancel />} />
            <Route path="/privacy" element={<LegalPage kind="privacy" />} />
            <Route path="/terms" element={<LegalPage kind="terms" />} />
            <Route path="/data-deletion" element={<LegalPage kind="deletion" />} />
          </Routes>
          <GlobalFooter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
